import {
  Activity as ActivityIcon,
  AlertOctagon as AlertOctagonIcon,
  Archive as ArchiveIcon,
  BarChart2 as BarChartIcon,
  Briefcase as BriefcaseIcon,
  Clipboard as ClipboardIcon,
  Cpu as CpuIcon,
  Grid as GridIcon,
  Eye as EyeIcon,
  File as FileIcon,
  Home as HomeIcon,
  Layers as LayersIcon,
  Package as PackageIcon,
  Play as PlayIcon,
  Shield as ShieldIcon,
  ShieldOff as ShieldOffIcon,
  ShoppingCart as ShoppingCartIcon,
  ThumbsUp as ThumbsUpIcon,
  Feather as FeatherIcon,
  Layout as LayoutIcon,
} from 'react-feather'
import { Description as DescriptionIcon } from '@material-ui/icons'

import { SVG } from 'components'

import { routes } from 'Routes'
import constants from 'constants/index'
import helpers from 'helpers'

const permission = constants.permissions

const mountMenuItems = (
  countBadgeResponse,
  hasProjectAssignmentsOrPermission = false,
  hasPrivacyByDesignAccess = false,
) => {
  return [
    {
      somePermissions: [permission.MARKETPLACE.VIEW],
      items: [
        {
          main: true,
          title: 'Marketplace',
          icon: ShoppingCartIcon,
          href: routes.marketplace.all,
          items: [
            {
              title: 'Início',
              href: routes.marketplace.all,
            },
            {
              title: 'Produtos e Serviços',
              href: routes.marketplace.products,
            },
            {
              title: 'Meus pedidos',
              href: routes.marketplace.orders,
            },
          ],
        },
      ],
    },
    {
      items: [
        {
          main: true,
          title: 'Trilha LGPD',
          icon: HomeIcon,
          href: routes.myLgpd.home,
        },
      ],
    },
    {
      items: [
        {
          main: true,
          title: 'Painel de Atividades',
          icon: GridIcon,
          href: routes.activitiesPanel.all,
          items: [
            {
              title: 'Atividades',
              href: routes.activitiesPanel.all,
              onClick: () =>
                helpers.mixpanel.track('Atividades', 'Módulo visualizado', {
                  action: 'atividades_modulo_visualizado',
                }),
            },
            {
              title: 'Configurações de Notificação',
              href: routes.activitiesPanel.notificationSettings,
              onClick: () =>
                helpers.mixpanel.track(
                  'Atividades',
                  'Configurações de notificação aberto',
                  { action: 'atividades_configuracoes_notificacao_aberto' },
                ),
            },
          ],
        },
      ],
    },
    {
      items: [
        {
          main: true,
          title: 'Indicadores',
          icon: BarChartIcon,
          href: routes.myLgpd.dashboard,
          somePermissions: permission.MY_LGPD.SHOW_TAGS,
        },
      ],
    },
    {
      items: [
        {
          main: true,
          title: 'Treinamentos',
          icon: PlayIcon,
          somePermissions: [
            permission.MOODLE_TRAININGS.VIEW,
            permission.NEW_PLATFORM_COURSE.CONFIG,
            permission.NEW_PLATFORM_COURSE.SHOW,
            permission.NEW_PLATFORM_COURSE.TREINING_PORTAL,
          ],
          alwaysUnlocked: true,
          items: [
            {
              title: 'Plataforma',
              href: '?redirectToMoodle=true',
              somePermissions: [
                permission.MOODLE_TRAININGS.VIEW,
                permission.NEW_PLATFORM_COURSE.TREINING_PORTAL,
              ],
              alwaysUnlocked: true,
            },
            {
              title: 'Comunidade',
              href: '?redirectToCommunity=true',
              permission: permission.MOODLE_TRAININGS.VIEW,
              alwaysUnlocked: true,
            },
            {
              title: 'Universidade da Privacidade',
              href: '?redirectToPrivacyUniversity=true',
              permission: permission.MOODLE_TRAININGS.VIEW,
              alwaysUnlocked: true,
            },
            {
              title: 'Configurar Cursos',
              href: routes.trainingCourses.all,
              somePermissions: [
                permission.NEW_PLATFORM_COURSE.SHOW,
                permission.NEW_PLATFORM_COURSE.CONFIG,
              ],
              alwaysUnlocked: true,
            },
          ],
        },
      ],
    },
    {
      items: [
        {
          somePermissions: [
            permission.DIAGNOSTICS.LIST,
            permission.COMPANY_FRAGILITIES.LIST_COMPANY_FRAGILITIES,
            permission.COMPANY_FRAGILITIES
              .LIST_COMPANY_FRAGILITIES_BY_DEPARTMENT,
            permission.COMPANY_FRAGILITIES.MANAGE_COMPANY_FRAGILITIES,
            permission.COMPANY_FRAGILITIES
              .MANAGE_COMPANY_FRAGILITIES_BY_DEPARTMENT,
          ],
          main: true,
          title: 'Diagnóstico',
          icon: FileIcon,
          href: routes.questionnaire.all,
          items: [
            {
              title: 'Questionários',
              href: routes.questionnaire.all,
            },
            {
              title: 'Medidas de segurança',
              href: routes.questionControls.all,
              permission: constants.permissions.DIAGNOSTICS.LIST,
            },
            {
              title: 'Ameaças',
              href: routes.companyFragilities.all,
              somePermissions: [
                permission.COMPANY_FRAGILITIES.LIST_COMPANY_FRAGILITIES,
                permission.COMPANY_FRAGILITIES
                  .LIST_COMPANY_FRAGILITIES_BY_DEPARTMENT,
                permission.COMPANY_FRAGILITIES.MANAGE_COMPANY_FRAGILITIES,
                permission.COMPANY_FRAGILITIES
                  .MANAGE_COMPANY_FRAGILITIES_BY_DEPARTMENT,
              ],
            },
          ],
        },
      ],
    },
    {
      items: [
        {
          main: true,
          title: 'Privacy By Design',
          icon: FeatherIcon,
          href: routes.privacyByDesign.all,
          show: hasPrivacyByDesignAccess,
        },
      ],
    },
    {
      items: [
        {
          main: true,
          title: 'Governança de IA',
          icon: CpuIcon,
          somePermissions: [
            permission.AI_INVENTORY.LIST,
            permission.AI_INVENTORY.SHOW,
            permission.AI_INVENTORY.MANAGE,
            permission.AI_INVENTORY.MANAGE_GUEST_PORTAL,
          ],
          href: routes.aiInventory.all,
          items: [
            {
              title: 'Inventário de IA',
              href: routes.aiInventory.all,
              somePermissions: [
                permission.AI_INVENTORY.LIST,
                permission.AI_INVENTORY.SHOW,
                permission.AI_INVENTORY.MANAGE,
                permission.AI_INVENTORY.MANAGE_GUEST_PORTAL,
              ],
            },
            {
              title: 'Indicadores',
              href: routes.aiInventory.indicators,
              somePermissions: [
                permission.AI_INVENTORY.LIST,
                permission.AI_INVENTORY.MANAGE,
              ],
            },
          ],
        },
      ],
    },
    {
      items: [
        {
          main: true,
          title: 'Processos',
          icon: LayersIcon,
          somePermissions: [
            permission.DATA_PROCESSES.LIST,
            permission.DATA_PROCESSES.LIST_AND_MANAGE_SUGGESTED,
            permission.DATA_PROCESSES.RESUME,
            permission.AUDITS.VIEW,
            permission.AUDITS.MANAGE,
            permission.AUDITS.FINALIZE,
            permission.ASSET_INVENTORY.SHOW,
            permission.ASSET_INVENTORY.MANAGE,
            permission.DATA_PROCESSES.CREATE,
            permission.DATA_PROCESS_TREATMENT.LIST,
            permission.DATA_PROCESS_TREATMENT.MANAGE,
          ],
          href: routes.dataProcess.all,
          items: [
            {
              title: 'Resumo',
              href: routes.dataProcess.resume,
              somePermissions: [
                permission.DATA_PROCESSES.LIST,
                permission.DATA_PROCESSES.RESUME,
                permission.DATA_PROCESSES.CREATE,
              ],
            },
            {
              title: 'Todos os processos',
              href: routes.dataProcess.all,
              somePermissions: [
                permission.DATA_PROCESSES.LIST,
                permission.DATA_PROCESSES.CREATE,
              ],
            },
            {
              title: 'Inventário de ativos',
              href: routes.assetInventory.all,
              somePermissions: [
                permission.ASSET_INVENTORY.SHOW,
                permission.ASSET_INVENTORY.MANAGE,
              ],
            },
            {
              title: 'Inteligência de dados',
              href: routes.dataIntelligence,
              somePermissions: [
                permission.DATA_PROCESSES.LIST,
                permission.DATA_PROCESSES.RESUME,
                permission.DATA_PROCESSES.CREATE,
              ],
            },
            {
              title: 'Novos sugeridos',
              href: routes.dataProcess.suggested,
              countToBadge: countBadgeResponse,
              permission: permission.DATA_PROCESSES.LIST_AND_MANAGE_SUGGESTED,
            },
            {
              title: 'Alterações sugeridas',
              href: routes.dataProcess.suggestedChanges,
              permission: constants.permissions.DATA_PROCESSES.CREATE,
            },
            {
              title: 'Tratamento',
              href: routes.dataProcess.treatment.all,
              somePermissions: [
                permission.DATA_PROCESSES.LIST,
                permission.DATA_PROCESSES.CREATE,
                permission.DATA_PROCESS_TREATMENT.LIST,
                permission.DATA_PROCESS_TREATMENT.MANAGE,
              ],
            },
            {
              title: 'Auditoria',
              href: routes.audits.all,
              somePermissions: [
                permission.AUDITS.VIEW,
                permission.AUDITS.MANAGE,
                permission.AUDITS.FINALIZE,
              ],
            },
          ],
        },
      ],
    },
    {
      somePermissions: [
        permission.INCIDENTS.LIST,
        permission.INCIDENTS.CREATE,
        permission.INCIDENTS.MANAGE,
      ],
      items: [
        {
          main: true,
          title: 'Incidentes',
          icon: AlertOctagonIcon,
          somePermissions: [
            permission.INCIDENTS.LIST,
            permission.INCIDENTS.CREATE,
            permission.INCIDENTS.MANAGE,
          ],
          href: routes.incidents.all,
        },
      ],
    },
    {
      items: [
        {
          main: true,
          title: 'Vulnerabilidades',
          icon: ActivityIcon,
          somePermissions: [
            permission.PHISHING.LIST,
            permission.PHISHING.MANAGE,
            permission.PHISHING.DASHBOARD,
          ],
          items: [
            {
              title: 'Indicadores',
              href: routes.phishing.dashboard,
              somePermissions: [
                permission.PHISHING.DASHBOARD,
                permission.PHISHING.MANAGE,
              ],
            },
            {
              title: 'Phishing',
              href: routes.phishing.all,
              somePermissions: [
                permission.PHISHING.LIST,
                permission.PHISHING.MANAGE,
              ],
            },
          ],
        },
      ],
    },
    {
      items: [
        {
          main: true,
          title: 'Relatórios',
          icon: ClipboardIcon,
          href: routes.reports.management,
          somePermissions: [
            permission.RIPD.EXPORT,
            permission.PHISHING.REPORT,
            permission.ASSET_INVENTORY.SHOW,
            permission.COMPANY_SUPPLIERS.SHOW,
          ],
          items: [
            {
              title: 'Relatório Gerencial',
              href: routes.reports.management,
              permission: permission.RIPD.EXPORT,
            },
            {
              title: 'Relatório de Impacto',
              href: routes.reports.ripd,
              permission: permission.RIPD.EXPORT,
            },
            {
              title: 'RoPA',
              href: routes.reports.ropa,
              permission: permission.RIPD.EXPORT,
            },
            {
              title: 'Relatório de Aceites',
              href: routes.reports.acceptance,
              permission: permission.RIPD.EXPORT,
            },
            {
              title: 'Prestação de Contas',
              href: routes.reports.accountability,
              permission: permission.RIPD.EXPORT,
            },
            {
              title: 'Relatório de Medidas de Segurança',
              href: routes.reports.control,
              permission: permission.RIPD.EXPORT,
            },
            {
              title: 'Relatório de Incidentes',
              href: routes.reports.incidents,
              permission: permission.RIPD.EXPORT,
            },
            {
              title: 'Relatório de Ameaças',
              href: routes.reports.fragility,
              permission: permission.RIPD.EXPORT,
            },
            {
              title: 'Relatório de Treinamento',
              href: routes.reports.trainingReport,
              permission: permission.RIPD.EXPORT,
            },
            {
              title: 'Relatório de Legítimo Interesse',
              href: routes.reports.lia,
              permission: permission.RIPD.EXPORT,
            },
            {
              title: 'Relatório de Consentimentos',
              href: routes.reports.consent,
              permission: permission.RIPD.EXPORT,
            },
            {
              title: 'Relatório de Consentimento de Cookies',
              href: routes.reports.cookiesConsents,
              permission: permission.RIPD.EXPORT,
            },
            {
              title: 'Relatório de Tags de Cookies',
              href: routes.reports.cookiesTags,
              permission: permission.RIPD.EXPORT,
            },
            {
              title: 'Relatório de Phishing',
              href: routes.reports.phishing,
              permission: permission.PHISHING.REPORT,
            },
            {
              title: 'Relatório de Auditoria',
              href: routes.reports.audit,
              permission: permission.RIPD.EXPORT,
            },
            {
              title: 'Relatório de Fornecedores',
              href: routes.reports.partners,
              permission: permission.COMPANY_SUPPLIERS.SHOW,
            },
            {
              title: 'Relatório de Inventário de Ativos',
              href: routes.reports.assetInventory,
              permission: permission.ASSET_INVENTORY.SHOW,
            },
            {
              title: 'Relatório Privacy By Design',
              href: routes.reports.privacyByDesign,
              permission: permission.RIPD.EXPORT,
            },
            {
              title: 'Relatório de Atividades',
              href: routes.reports.kanbanTasks,
              somePermissions: [
                permission.KANBAN_TASKS.LIST,
                permission.KANBAN_TASKS.MANAGE,
              ],
            },
          ],
        },
      ],
    },
    {
      items: [
        {
          main: true,
          title: 'Canal de Comunicação',
          icon: ShieldIcon,
          alwaysUnlocked: true,
          href: routes.privacyPortal.stamps,
          somePermissions: [
            permission.PRIVACY_POLICIES.STAMP,
            permission.PRIVACY_PORTAL_THEMES.SHOW,
            permission.PRIVACY_PORTAL_THEMES.MANAGE,
            permission.TITULAR_TICKETS.MANAGE_CONFIGURATIONS,
            permission.TITULAR_TICKETS.LIST,
            permission.TITULAR_TICKETS.INTERACT,
          ],
          items: [
            {
              title: 'Solicitações de titulares',
              href: routes.privacyPortal.tickets.all,
              alwaysUnlocked: true,
              somePermissions: [
                permission.TITULAR_TICKETS.MANAGE_CONFIGURATIONS,
                permission.TITULAR_TICKETS.LIST,
                permission.TITULAR_TICKETS.INTERACT,
              ],
            },
            {
              title: 'Meios de Contato',
              href: routes.privacyPortal.stamps,
              somePermissions: [permission.PRIVACY_POLICIES.STAMP],
              alwaysUnlocked: true,
            },
            {
              title: 'Personalização',
              href: routes.privacyPortal.settings,
              somePermissions: [
                permission.PRIVACY_PORTAL_THEMES.SHOW,
                permission.PRIVACY_PORTAL_THEMES.MANAGE,
              ],
              alwaysUnlocked: true,
            },
          ],
        },
      ],
    },
    {
      items: [
        {
          main: true,
          title: 'Canal de Denúncias',
          icon: ShieldOffIcon,
          alwaysUnlocked: true,
          somePermissions: [
            permission.COMPLAINTS.LIST,
            permission.COMPLAINTS.REGISTER_RESPONSIBLE,
            permission.COMPLAINTS.SHOW,
            permission.COMPLAINT_MESSAGES.CREATE,
            permission.COMPLAINTS.ACTIVATE_COMPLAINTS,
            permission.COMPLAINTS.MANAGE_CONFIGURATIONS,
            permission.COMPLAINTS.LIST_CONFIGURATIONS,
          ],
          items: [
            {
              title: 'Denúncias',
              href: routes.complaint.all,
              somePermissions: [
                permission.COMPLAINTS.LIST,
                permission.COMPLAINTS.SHOW,
                permission.COMPLAINT_MESSAGES.CREATE,
                permission.COMPLAINTS.ACTIVATE_COMPLAINTS,
              ],
            },
            {
              title: 'Configurações',
              href: routes.complaint.config,
              somePermissions: [
                permission.COMPLAINTS.REGISTER_RESPONSIBLE,
                permission.COMPLAINTS.MANAGE_CONFIGURATIONS,
                permission.COMPLAINTS.LIST_CONFIGURATIONS,
              ],
            },
          ],
        },
      ],
    },
    {
      items: [
        {
          main: true,
          title: 'Gestão de Fornecedores',
          icon: PackageIcon,
          somePermissions: [
            permission.COMPANY_SUPPLIERS.SHOW,
            permission.COMPANY_SUPPLIERS.UPDATE,
            permission.COMPANY_SUPPLIER_QUESTIONNAIRES_RECEIVED.MANAGE,
            permission.SUPPLIER_SUGGESTIONS.MANAGE,
          ],
          items: [
            {
              title: 'Meus Fornecedores',
              href: routes.thirdPartyManagements.mySuppliers.all,
              somePermissions: [
                permission.COMPANY_SUPPLIERS.SHOW,
                permission.COMPANY_SUPPLIERS.UPDATE,
              ],
            },
            {
              title: 'Questionários Recebidos',
              href: routes.thirdPartyManagements.questionnairesReceived,
              permission:
                permission.COMPANY_SUPPLIER_QUESTIONNAIRES_RECEIVED.MANAGE,
            },
            {
              title: 'Pré-Avaliação',
              href: routes.thirdPartyManagements.preAvaliations,
              somePermissions: [
                permission.COMPANY_SUPPLIERS.SHOW,
                permission.COMPANY_SUPPLIERS.UPDATE,
              ],
            },
            {
              title: 'Sugestões',
              href: routes.thirdPartyManagements.suggestions,
              permission: permission.SUPPLIER_SUGGESTIONS.MANAGE,
            },
          ],
        },
      ],
    },
    {
      items: [
        {
          main: true,
          title: 'Consentimentos',
          icon: ThumbsUpIcon,
          alwaysUnlocked: true,
          somePermissions: [
            permission.CONSENTS.LIST,
            permission.CONSENT_RECEIPTS.LIST,
          ],
          href: routes.consent.all,
          items: [
            {
              title: 'Formulários',
              href: routes.consent.all,
              permission: permission.CONSENTS.LIST,
            },
            {
              title: 'Recibos',
              href: routes.consent.consentReceipt,
              permission: permission.CONSENT_RECEIPTS.LIST,
            },
          ],
        },
      ],
    },
    {
      items: [
        {
          main: true,
          title: 'Projetos de Governança',
          show: hasProjectAssignmentsOrPermission,
          icon: DescriptionIcon,
          alwaysUnlocked: true,
          href: routes.governanceProjects.all,
        },
      ],
    },
    {
      items: [
        {
          main: true,
          title: 'Empresa',
          icon: BriefcaseIcon,
          somePermissions: [
            permission.DEPARTMENTS.LIST,
            permission.USERS.LIST,
            permission.PROFILES.LIST,
            permission.COMMITTEES.LIST,
            permission.EXTERNAL_PLATFORM_INTEGRATIONS.LIST,
            permission.EXTERNAL_PLATFORM_INTEGRATIONS.MANAGE,
            permission.EXTERNAL_PLATFORM_INTEGRATIONS.UPDATE,
          ],
          items: [
            {
              title: 'Departamentos',
              href: routes.department.all,
              permission: permission.DEPARTMENTS.LIST,
            },
            {
              title: 'Usuários',
              href: routes.user.all,
              permission: permission.USERS.LIST,
            },
            {
              title: 'Perfis',
              permission: constants.permissions.PROFILES.LIST,
              href: routes.profiles.all,
            },
            {
              title: 'Comitês',
              permission: constants.permissions.COMMITTEES.LIST,
              href: routes.committees.all,
            },
            {
              title: 'Integrações',
              href: routes.externalPlatformIntegrations.all,
              somePermissions: [
                permission.EXTERNAL_PLATFORM_INTEGRATIONS.LIST,
                permission.EXTERNAL_PLATFORM_INTEGRATIONS.MANAGE,
                permission.EXTERNAL_PLATFORM_INTEGRATIONS.UPDATE,
              ],
            },
          ],
        },
      ],
    },
    {
      items: [
        {
          main: true,
          title: 'Monitoramento',
          icon: EyeIcon,
          somePermissions: [
            permission.MONITORING_MANAGEMENT_KPI.LIST,
            permission.MONITORING_MANAGEMENT_KPI.MANAGE,
            permission.MONITORING_MANAGEMENT_NC.LIST,
            permission.MONITORING_MANAGEMENT_NC.MANAGE,
            permission.MONITORING_MANAGEMENT_PDCA.LIST,
            permission.MONITORING_MANAGEMENT_PDCA.MANAGE,
            permission.MONITORING_MANAGEMENT_PMC.LIST,
            permission.MONITORING_MANAGEMENT_PMC.MANAGE,
          ],
          items: [
            {
              title: 'KPI',
              somePermissions: [
                permission.MONITORING_MANAGEMENT_KPI.LIST,
                permission.MONITORING_MANAGEMENT_KPI.MANAGE,
              ],
              href: routes.kpi.all,
            },
            {
              title: 'Melhoria Contínua',
              somePermissions: [
                permission.MONITORING_MANAGEMENT_PMC.LIST,
                permission.MONITORING_MANAGEMENT_PMC.MANAGE,
              ],
              href: routes.pmc.all,
            },
            {
              title: 'Não Conformidade',
              somePermissions: [
                permission.MONITORING_MANAGEMENT_NC.LIST,
                permission.MONITORING_MANAGEMENT_NC.MANAGE,
              ],
              href: routes.nc.all,
            },
            {
              title: 'PDCA',
              somePermissions: [
                permission.MONITORING_MANAGEMENT_PDCA.LIST,
                permission.MONITORING_MANAGEMENT_PDCA.MANAGE,
              ],
              href: routes.pdca.all,
            },
          ],
        },
      ],
    },
    {
      items: [
        {
          main: true,
          title: 'Gestão de Mudanças',
          icon: LayoutIcon,
          href: routes.changesManagement.all,
          somePermissions: [
            constants.permissions.CHANGES_MANAGEMENT.LIST,
            constants.permissions.CHANGES_MANAGEMENT.MANAGE,
          ],
        },
      ],
    },
    {
      items: [
        {
          main: true,
          title: 'Documentos',
          icon: ArchiveIcon,
          somePermissions: [
            constants.permissions.PRIVACY_POLICIES.LIST,
            constants.permissions.PRIVACY_POLICIES.CREATE,
            constants.permissions.DOCUMENTS_TEMPLATE.LIST,
          ],
          href: routes.documents.all,
        },
      ],
    },
    {
      items: [
        {
          main: true,
          title: 'Cookies',
          permission: permission.COOKIES.MANAGE,
          icon: SVG.CookieIcon,
          alwaysUnlocked: true,
          href: routes.cookies.banners,
          items: [
            {
              title: 'Meus banners',
              href: routes.cookies.banners,
            },
            {
              title: 'Consentimentos',
              href: routes.cookies.consents,
            },
          ],
        },
      ],
    },
  ]
}

export default mountMenuItems
